/** @format */

import { useRef } from 'react';

import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import PropTypes from 'prop-types';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import InputIcon from 'react-multi-date-picker/components/input_icon';

import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';

const Datepicker = ({
	handleChange,
	onChange,
	value,
	name,
	format = 'YYYY/MM/DD',
	showSelectTime = false,
	closeOnSelect = false,
}) => {
	const datePickerRef = useRef();

	const emitChange = (dateValue) => {
		if (onChange) {
			onChange(dateValue);
			return;
		}

		if (handleChange) {
			handleChange(name, dateValue, true);
		}
	};

	return (
		<DatePicker
			ref={datePickerRef}
			render={<InputIcon />}
			zIndex='9999999999999'
			calendar={persian}
			locale={persian_fa}
			value={value}
			plugins={showSelectTime ? [<TimePicker position='bottom' />] : []}
			name={name}
			portal
			format={format}
			onChange={(e) => {
				if (!e) {
					return;
				}

				let hour =
					e.hour.toString().length === 1 ? '0' + e.hour : e.hour;
				let min =
					e.minute.toString().length === 1 ? '0' + e.minute : e.minute;
				let sec =
					e.second.toString().length === 1 ? '0' + e.second : e.second;
				const formatted = showSelectTime
					? `${e.year}/${e.month}/${e.day} ${hour}:${min}:${sec}`
					: `${e.year}/${e.month}/${e.day}`;

				emitChange(formatted);

				if (closeOnSelect && !showSelectTime && datePickerRef.current) {
					datePickerRef.current.closeCalendar();
				}
			}}
		/>
	);
};

Datepicker.propTypes = {
	handleChange: PropTypes.func,
	onChange: PropTypes.func,
	value: PropTypes.any,
	name: PropTypes.string,
	closeOnSelect: PropTypes.bool,
};

export default Datepicker;
